import { useEffect } from "react";
import ReactDOM from "react-dom";

const DeletePrompt = ({
  showModal,
  onDelete,
  onCancel,
  title = "Remove this item?",
  message = "This item will be permanently removed from your list.",
}) => {
  useEffect(() => {
    if (showModal) document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [showModal]);

  if (!showModal) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 flex items-center justify-center p-4 font-poppins bg-black/30 backdrop-blur-sm"
      style={{ zIndex: 99999, animation: "dpFadeIn 0.18s ease" }}
      onClick={onCancel}
    >
      <div
        className="relative w-full max-w-[22rem] rounded-2xl overflow-hidden bg-[#0e1e1c] border border-[#1e4a46] shadow-2xl"
        style={{ animation: "dpModalIn 0.24s cubic-bezier(0.16,1,0.3,1)" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Top accent */}
        <div className="h-[3px] w-full bg-gradient-to-r from-[#162c2a] via-[#5fbdb3] to-[#ff601e]" />

        <div className="px-7 py-7">
          {/* Icon */}
          <div className="flex justify-center mb-5">
            <div className="w-14 h-14 rounded-[14px] flex items-center justify-center bg-red-500/10 border border-red-500/25">
              <svg
                width="26"
                height="26"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#f87171"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6" />
                <path d="M8 6V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2" />
                <path d="M10 11v6M14 11v6" />
                <path d="M5 6l1 14c.1 1.1.9 2 2 2h8c1.1 0 1.9-.9 2-2l1-14" />
              </svg>
            </div>
          </div>

          {/* Text */}
          <h2
            className="text-center text-[1.05rem] font-bold text-white mb-2 tracking-tight"
            style={{ fontFamily: "'Nunito',sans-serif" }}
          >
            {title}
          </h2>
          <p className="text-center text-[0.85rem] font-medium text-[#7abcb8] mb-6 leading-relaxed">
            {message}
          </p>

          {/* Buttons */}
          <div className="flex gap-3">
            <button
              onClick={onCancel}
              className="flex-1 rounded-xl border border-[#1e4a46] bg-transparent py-3 text-[0.88rem] font-semibold text-[#7abcb8] cursor-pointer transition-all hover:border-[#5fbdb3] hover:text-white"
            >
              Cancel
            </button>
            <button
              onClick={onDelete}
              className="flex-1 rounded-xl border-none bg-red-500 hover:bg-red-600 py-3 text-[0.88rem] font-extrabold uppercase tracking-widest text-white cursor-pointer transition-all shadow-[0_4px_14px_rgba(239,68,68,0.4)]"
              style={{ fontFamily: "'Nunito',sans-serif" }}
            >
              Delete
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes dpFadeIn  { from { opacity:0; } to { opacity:1; } }
        @keyframes dpModalIn { from { opacity:0; transform:translateY(22px) scale(0.97); } to { opacity:1; transform:translateY(0) scale(1); } }
      `}</style>
    </div>,
    document.body,
  );
};

export default DeletePrompt;
